import * as Mime from 'mime';
import { ApiService } from '../services/api/ApiService';
export class FileHelper {
    /**
     * Format bytes as human-readable text.
     * Based on: https://stackoverflow.com/questions/10420352/converting-file-size-in-bytes-to-human-readable-string
     *
     * @param bytes Number of bytes.
     * @param dp Number of decimal places to display.
     *
     * @return Formatted string.
     */
    static humanFileSize(bytes, dp = 0) {
        const thresh = 1024;
        if (Math.abs(bytes) < thresh) {
            return `${bytes} B`;
        }
        const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        let u = -1;
        const r = 10 ** dp;
        let remainingBytes = bytes;
        do {
            remainingBytes /= thresh;
            u += 1;
        } while (Math.round(Math.abs(remainingBytes) * r) / r >= thresh && u < units.length - 1);
        return `${remainingBytes.toFixed(dp)} ${units[u]}`;
    }
    /**
     * Given a url gets a File object.
     * @param url url.
     * @param fileName file name.
     * @returns a File.
     */
    static async urlToFile(url, fileName) {
        const apiService = new ApiService(url);
        const reponse = await apiService.get('', undefined, 'blob');
        const blob = reponse.data;
        const mimeType = Mime.getType(fileName) || '';
        return new File([blob], fileName, { type: mimeType });
    }
}
//# sourceMappingURL=fileHelper.js.map